"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var TimezoneGroup =
/*#__PURE__*/
function (_Record) {
  (0, _inherits2.default)(TimezoneGroup, _Record);

  function TimezoneGroup() {
    (0, _classCallCheck2.default)(this, TimezoneGroup);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TimezoneGroup).apply(this, arguments));
  }

  (0, _createClass2.default)(TimezoneGroup, [{
    key: "timezoneForMomentTimezone",
    value: function timezoneForMomentTimezone(timezone) {
      return this.timezones.find(function (tz) {
        return tz.momentTimezones.includes(timezone);
      });
    }
  }]);
  return TimezoneGroup;
}((0, _immutable.Record)({
  groupName: '',
  timezones: (0, _immutable.List)()
}));

exports.default = TimezoneGroup;
module.exports = exports.default;